module.exports = __webpack_public_path__ + "static/media/second_factor_active.8fdd71d1.svg";